import { useQuery } from '@tanstack/react-query'
import { CircularProgress, Alert } from '@mui/material'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Pagination from '../Paginations'
import { getAllLabels } from '../../api/labels'

const AdminLabels = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const itemsPerPage = 25

    // Replace useState + useEffect with React Query
    const { 
        data: labels = [], 
        isLoading, 
        error 
    } = useQuery({
        queryKey: ['labels'],
        queryFn: getAllLabels,
        select: (data) => data.labels.map(label => ({
            name: label.name,
            country: label.country,
            email: label.users_profile?.email || 'N/A',
            key: label.users_profile.user_id,
            index: label.id
        }))
    })

    // Pagination calculations
    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = labels.slice(indexOfFirstItem, indexOfLastItem)
    const totalPages = Math.ceil(labels.length / itemsPerPage)

    return (
        <div className="admin-page py-5">
            <div className='container'>
                <h1 className='dash-title'>Labels</h1>
                <div className="row">
                    <div className="col-12 mt-4">
                        <div className="dash-card">
                            <div className="dash-card-heading">
                                <h2 className="dash-card-title">Labels</h2>
                            </div>

                            {/* Loading State */}
                            {isLoading && (
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    padding: '50px 0' 
                                }}>
                                    <CircularProgress />
                                </div>
                            )}

                            {/* Error State */}
                            {error && (
                                <Alert 
                                    severity="error" 
                                    sx={{ margin: '20px 0' }}
                                >
                                    Error loading labels: {error.message}
                                </Alert>
                            )}

                            {/* Data Table */}
                            {!isLoading && !error && (
                                <>
                                    <div className="table-responsive mt-3">
                                        <table className="table dash-table">
                                            <thead>
                                                <tr>
                                                    <td>User</td>
                                                    <td>Name</td>
                                                    <td>Country</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems.map((label, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div className="table-item">
                                                                {label.email}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="table-item">
                                                                {label.name}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="table-item">
                                                                {label.country}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="table-item d-flex">
                                                                <Link
                                                                    to={`edit/${label.key}/${label.index}`} 
                                                                    className="table-action-btn a-blue me-1"
                                                                >
                                                                    <i className="fi fi-rr-pencil"></i>
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination */}
                                    <Pagination 
                                        currentPage={currentPage} 
                                        totalPages={totalPages} 
                                        handlePageChange={setCurrentPage} 
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminLabels